function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.7 27.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 2.75,
    width: 24,
    height: 22,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.85,
    cy: 13.85,
    r: 13.6,
    style: {
      fill: "#bcbcbc",
      stroke: "#cbcbcb",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5,6.25l.9-.9,15.9,15.9-.9.9L5.5,6.25Zm-.1,5.8c-1,.9-1.5,2.1-1.5,3.6,0,1.4.6,2.7,1.6,3.6s2.3,1.4,3.7,1.4h8.9l-9.9-9.9c-1.1.2-2.1.6-2.8,1.3Zm17.1,7.6c.9-.7,1.4-1.8,1.4-3.1,0-2.4-1.9-3.7-3.8-4-.3-1.6-.9-3-2-4-1.1-1.1-2.6-1.7-4.2-1.7-1.2,0-2.3.3-3.2,1l11.8,11.8h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnected);
export default __webpack_public_path__ + "static/media/NotConnected.dc89725263d96dddb202315ea84a4c5d.svg";
export { ForwardRef as ReactComponent };